import { Badge } from '@/components/ui/badge';
import type { PaymentState } from '@/lib/payments';

const stateVariantMap: Record<
  PaymentState,
  'neutral' | 'pending' | 'active' | 'alert'
> = {
  Scheduled: 'neutral',
  Pending: 'pending',
  Paid: 'active',
  Overdue: 'alert',
};

export function PaymentStatusBadge({ state }: { state: PaymentState }) {
  return <Badge variant={stateVariantMap[state]}>{state}</Badge>;
}
